import React, { FC } from "react";
import {
  PageEnum,
  SuppliersComplexReportSearchParamsModel,
} from "../../../models";
import { getSystemLanguageId, getUserId } from "../../../utils";
import {
  ReportPage,
  ReportSuppliersComplexSearchPanel,
} from "../../../components";
import { searchReportAllSuppliersTransaction } from "../../../serviceBroker/suppliersReportApiServiceBroker";

export const ReportAllSuppliersTransactions: FC = () => {
  const initialState: SuppliersComplexReportSearchParamsModel = {
    Lang: getSystemLanguageId(),
  };
  return (
    <ReportPage
      InitialState={initialState}
      SearchApi={searchReportAllSuppliersTransaction}
      searchHeader="Report All Suppliers Transactions"
      SearchPanel={ReportSuppliersComplexSearchPanel}
      formId={PageEnum.ReportFollowSuppliersInTransaction}
    />
  );
};
